import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  title: {
    margin: 0,
    marginLeft: 5,
  },
  materielRightHeader: {
    "& button": {
      padding: "8px !important",
    },
  },
  materielHeader: {
    padding: "6px !important",
  },
  bottomContent: {
    display: "flex",
  },
  tableContainer: {
    "& thead": {
      display: "none",
    },
    "& table": {
      borderSpacing: "0 10px",
      borderCollapse: "separate",
      minWidth: "820px !important",
    },
    "& td:nth-child(1), & th:nth-child(1)": {
      width: "100% !important",
    },
    "& td:nth-child(2), & th:nth-child(2)": {
      width: "72px !important",
      maxWidth: "72px !important",
      whiteSpace: "nowrap",
    },
    "& td:nth-child(3), & th:nth-child(3)": {
      width: "164px !important",
      maxWidth: "164px !important",
      whiteSpace: "nowrap",
      "& span": {
        padding: "2px 12px",
        boxSizing: "border-box",
        width: "100%",
      },
    },
    "& td:nth-child(4), & th:nth-child(4)": {
      width: "152px !important",
      maxWidth: "152px !important",
      whiteSpace: "nowrap",
      "& [class*='tableCellIn']": {
        justifyContent: "center",
      },
    },
    "& td": {
      borderTop: `1px solid ${theme.color.gray2}`,
      "&:first-child": {
        borderLeft: `1px solid ${theme.color.gray2}`,
      },
      "&:last-child": {
        borderRight: `1px solid ${theme.color.gray2}`,
      },
    },
    "& [class*='ellipsis']": {
      width: "100%",
    },
  },
  productCartTable: {
    "& table td:nth-child(3)": {
      whiteSpace: "nowrap !important",
    },
  },
  CircularProgress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  navigationStep: {
    marginTop: 18,
    marginBottom: 18,
    display: "flex",
    justifyContent: "space-between",
  },
  dialogContent: {
    textAlign: "center",
  },
  paperModal: {
    flex: "0 1 500px",
    width: 500,
    maxWidth: "100%",
  },
  CreateEdbPage_Popin: {
    "& .MuiDrawer-paper": {
      width: "786px !important",
      overflowY: "unset !important",
    },
  },
  MenuContainer: {
    "& .MuiListItemIcon-root": {
      minWidth: 30,
    },
    "& .MuiTypography-body1": {
      fontFamily: theme.font.workSans,
    },
  },
  BtnOnPopper: {
    "&.MuiButtonGroup-grouped": {
      padding: 6,
      justifyContent: "flex-start",
      minWidth: 166,
      background: theme.color.white,
    },
  },
  productTableWrapper: {
    cursor: "pointer",
  },
  productDesignation: {
    fontWeight: 600,
    paddingBottom: 10,
    display: "box",
    maxHeight: 33,
    textOverflow: "ellipsis",
    overflow: "hidden",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": 2,
  },
  cartContent: {
    display: "flex",
    flexDirection: "column",
  },
}));
